import { createProfile } from "./createProfile";
import { createProfileParameterSuggestion } from "./createProfileParameterSuggestion";
import { getCachedQuickApplyParameters } from "./getCachedQuickApplyParameters";
import { getConcernNames } from "./getConcernNames";
import { getIdentityProviderUserInfoOverrides } from "./getIdentityProviderUserInfoOverrides";
import { getCvPortalCandidateTokenForCurrentUser } from "./getCvPortalCandidateTokenForCurrentUser";
import { impersonationLogin } from "./impersonationLogin";
import { login } from "./login";
import { me } from "./me";
import { myVerifiedProfiles } from "./myVerifiedProfiles";
import { quickApply } from "./quickApply";
import { saveCachedQuickApplyParametersOverride } from "./saveCachedQuickApplyParametersOverride";
import { saveIdentityProviderUserInfoOverrides } from "./saveIdentityProviderUserInfoOverrides";
import { saveLocaleChoice } from "./saveLocaleChoice";
import { sendAttachProfileEmail } from "./sendAttachProfileEmail";
import { sendOtc } from "./sendOtc";
import { sendPhoneOtc } from "./sendPhoneOtc";
import { markEmailVerified } from "./markEmailVerified";
import { markPhoneVerified } from "./markPhoneVerified";
import { removeEmailVerification } from "./removeEmailVerification";
import { attachExistingCandidatesByVerifiedEmail } from "./attachExistingCandidatesByVerifiedEmail";
import { getVerifiedEmails } from "./getVerifiedEmails";
import { getVerifiedPhones } from "./getVerifiedPhones";
import { setActiveProfile } from "./setActiveProfile";
import { profileTimesheetsInConcern } from "./profileTimesheetsInConcern";
import { whoAmI } from "./whoAmI";

export const authAPI = {
  getCvPortalCandidateTokenForCurrentUser,
  login,
  whoAmI,
  me,
  sendAttachProfileEmail,
  sendOtc,
  sendPhoneOtc,
  markEmailVerified,
  markPhoneVerified,
  removeEmailVerification,
  attachExistingCandidatesByVerifiedEmail,
  getVerifiedEmails,
  getVerifiedPhones,
  createProfile,
  createProfileParameterSuggestion,
  myVerifiedProfiles,
  saveLocaleChoice,
  getConcernNames,
  quickApply,
  impersonationLogin,
  getCachedQuickApplyParameters,
  saveCachedQuickApplyParametersOverride,
  getIdentityProviderUserInfoOverrides,
  saveIdentityProviderUserInfoOverrides,
  setActiveProfile,
  profileTimesheetsInConcern,
};

export type AuthAPI = typeof authAPI;
